import { render, staticRenderFns } from "./InstructionWindowFooter.vue?vue&type=template&id=786c10e2&scoped=true"
import script from "./InstructionWindowFooter.vue?vue&type=script&lang=ts"
export * from "./InstructionWindowFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c10e2",
  null
  
)

export default component.exports